module.exports = __webpack_public_path__ + "David-Dias.jpg?9067ad1189ec117dd93f7cabaf394017";


//////////////////
// WEBPACK FOOTER
// ./src/images/David-Dias.jpg
// module id = 377
// module chunks = 0